<template>
  <div class="swper">
    <div v-show="Path" class="pc-banner" style="height: 500px;">
      <el-carousel height="500px" :interval="10000" indicator-position="outside" arrow="never">
        <el-carousel-item v-for="(img, index) in Path" :key="index">
          <div class="carousel-item">
            <div class="copy-text">
              <div class="copy-text-title">{{ img.displayName }}</div>
              <div class="copy-text-tip">{{ img.shortName }}</div>
              <div class="copy-text-go" @click="getJumdetails(index)">
                MORE
                <img src="@/assets/images/more1.png" />
              </div>
            </div>
            <img :src="img.resUrl" class="rounded-image" @click="getJumdetails(index)" />
          </div>
        </el-carousel-item>
      </el-carousel>
    </div>
    <div class="pc-data-body-mt">
      <div :class="{ animation: mt_animation }" class="pc-data-common-title">
        <img class="path_l" src="@/assets/images/title1.png" />
        <!-- <div class="pc-data-common-title-right">
          more
          <img src="@/assets/images/more.png" />
        </div> -->
      </div>
      <div :class="{ animation: mt_animation }" class="pc-data-mt-list">
        <div v-for="(item, index) in mediaList" :key="index" class="media_list">
          <div class="media" @click="getalljum(index)">
            <div class="date_all">
              <div class="all_month" style="color: #fff;">{{ item.month }}</div>
              <div class="all_line">
                <img src="@/assets/images/li.png" style="width: 16px;height: 26px;" />
              </div>
              <div class="all_l">
                <div class="all_day" style="color: #fff;">{{ item.day }}</div>
                <div class="all_year" style="color: #fff;">{{ item.year }}</div>
              </div>
            </div>
            <div class="media_title">{{ item.title }}</div>
            <div class="media_span">{{ item.adRemark }}</div>
          </div>
          <div class="media_path">
            <img :src="item.headerImg" />
          </div>
        </div>

        <div class="m-page">
          <el-pagination background @current-change="sizeChange" @prev-click="sizeChange" @next-click="sizeChange"
            layout="prev, pager, next" :total="newtotal">
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getnewbaList, getAltlist } from "../../../network/home.js";
export default {
  data() {
    const today = new Date();
    return {
      Path: [],
      limit: 10,
      mt_animation: false,
      mediaList: [],
      year: today.getFullYear(),
      month: today.getMonth() + 1,
      Days: today.getDate(),
      newpage: 1,
      newtotal: 0,
      newlimit: 10
    };
  },
  mounted() {
    this.getList();
    this.getallList();
  },
  methods: {
    sizeChange(e) {
      this.newpage = e;
      this.getallList();
    },
    // 获取轮播图列表
    async getList() {
      try {
        let res = await getnewbaList();
        this.Path = res.data;
        return res;
      } catch (e) {
        console.log(e);
      }
    },

    async getallList() {
      try {
        let res = await getAltlist({
          limit: this.limit,
          page: this.newpage,
          status: 1,
        });
        res.data.map(time => {
          time.year = time.createTime.substring(0, 4);
          (time.month = time.createTime.substring(5, 7)),
            (time.day = time.createTime.substring(8, 10));
        });
        this.mediaList = res.data;
        this.newtotal = parseInt(res.count);
      } catch (e) {
        console.log(e);
      }
    },
    getalljum(index) {
      let id = this.mediaList[index].id;
      this.$router.push({ path: "/newDetails", query: { id: id } });
    },
    // 跳转到详情
    getJumdetails(index) {
      let id = this.Path[index].relationId;
      let relationType = this.Path[index].relationType;
      let itemUrl = this.Path[index].itemUrl;
      if (relationType === 3) {
        window.open(itemUrl);
      } else if (relationType === 6) {
        //公告详情
        this.$router.push({ path: "/newDetails", query: { id: id } });
      } else if (relationType === 5) {
        //节目详情
        this.$router.push({ path: "/details", query: { id: id } });
      }
    }
  }
};
</script>

<style scoped>
img {
  width: 100%;
  height: 430px;
  cursor: pointer;
}

.newsr_title {
  background-color: #d6b181;
  line-height: 40px;
  font-size: 21px;
  color: #fff;
  font-weight: bold;
  padding-left: 10px;
}

/* 圆形指示灯样式 */
::v-deep .el-carousel__indicator--horizontal .el-carousel__button {
  width: 10px;
  height: 10px;

  background: #80807f;
  border: 1px solid #80807f;
  border-radius: 50%;
  opacity: 0.3;
}

::v-deep .el-carousel__indicator--horizontal.is-active .el-carousel__button {
  width: 10px;
  height: 10px;
  background: #dcc12b;
  border: 1px solid #dcc12b;
  border-radius: 50%;
  opacity: 1;
}

::v-deep .el-carousel__indicators--outside {
  text-align: end;
  z-index: 999;
  position: absolute;
  bottom: 0px;
  right: 10px;
}

/* 隐藏 el-carousel 的左箭头 */
::v-deep .el-carousel__arrow--left {
  display: none;
}

/* 隐藏 el-carousel 的右箭头 */
::v-deep .el-carousel__arrow--right {
  display: none;
}

.carousel-item {
  position: relative;
  text-align: center;
  display: flex;
}

.carousel-text {
  position: fixed;
  bottom: 0;
  left: 50%;
  -webkit-transform: translateX(-50%);
  transform: translateX(-50%);
  background-color: rgba(0, 0, 0, 0.5);
  color: white;
  padding: 10px;
  border-radius: 5px;
  width: 100%;
}

.carousel-text h3 {
  margin: 0;
  font-size: 1.2em;
}

.carousel-text p {
  margin: 5px 0 0;
  font-size: 0.9em;
  text-align: left;
  padding: 0 20px;
  box-sizing: border-box;
}

.rounded-image {
  border-top-right-radius: 50px;
  border-bottom-right-radius: 50px;
  width: 720px;
  height: 500px;
  object-fit: cover;
  cursor: pointer;
}

/* 媒体报道 */
.pc-data-body-mt {
  width: 100%;
  margin-top: 78px;
}

.media_list {
  display: flex;
  justify-content: space-between;
  margin-bottom: 50px;
  cursor: pointer;
}

.media_path img {
  width: 647px;
  height: 402px;
  object-fit: cover;
}

.media {
  width: 40%;
}

.pc-data-common-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 89px;
}

.pc-data-common-title-right {
  font-weight: 400;
  font-size: 14px;
  color: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}

.pc-data-common-title-right img {
  width: 24px;
  height: 24px;
}

.path_l {
  width: 411px;
  height: 77px;
}

.date_all {
  display: flex;
  text-align: center;
  padding-bottom: 45px;
  align-items: center;
}

.all_day {
  font-weight: 800;
  font-size: 30px;
  color: #fff;
}

.all_year {
  font-family: OPPOSans, OPPOSans;
  font-weight: 500;
  font-size: 20px;
  color: #fff;
}

.all_month {
  font-weight: 800;
  font-size: 80px;
  color: #fff;
}

.all_line {
  margin-right: 7px;
  margin-left: 10px;
}

.media_title {
  font-weight: bold;
  font-size: 25px;
  color: #ffffff;
  line-height: 40px;
  margin-bottom: 32px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  text-overflow: ellipsis;
  box-orient: vertical;
  line-height: 1.5;
  max-height: 3em;
}

.media_span {
  font-weight: 400;
  font-size: 14px;
  color: #ffffff;
  line-height: 28px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  text-overflow: ellipsis;
  box-orient: vertical;
  line-height: 1.5;
  max-height: 3em;
}

/* 自定义指示器样式 */
.pc-banner>>>.el-carousel__button {
  width: 12px;
  height: 12px;
  border-radius: 50%;
}

.m-page {
  width: 100%;
  height: 32px;
  display: flex;
  justify-content: center;
  margin-top: 50px;
}

.m-page>>>.el-pagination.is-background .el-pager li:not(.disabled).active {
  width: 30px;
  height: 30px;
  background: #fff;
  border-radius: 6px 6px 6px 6px;
  border: 1px solid #fff !important;
  color: #000 !important;
  margin: 0 10px;
}

.m-page>>>.el-pagination.is-background .el-pager li {
  width: 30px;
  height: 30px;
  border-radius: 6px 6px 6px 6px;
  border: 1px solid #fff;
  background: #000;
  color: #fff;
  margin: 0 10px;
}

.m-page>>>.el-pagination.is-background .btn-prev,
.el-pagination.is-background .el-pager li {
  width: 30px;
  height: 30px;
  border-radius: 5px 5px 5px 5px;
  border: 1px solid #fff;
  color: #fff;
  background: #000;
  margin: 0 10px;
}

.m-page>>>.el-pagination.is-background .btn-next {
  width: 30px;
  height: 30px;
  border-radius: 5px 5px 5px 5px;
  border: 1px solid #fff;
  color: #fff;
  background: #000;
  margin: 0 10px;
}
.copy-text{
  width: 720px;
  height: 500px;
  border-top-left-radius: 50px;
  border-bottom-left-radius: 50px;
  background-color: #ffffff;
  display: flex;
  flex-direction: column;
}
.copy-text-title{
  display: inline-block; /* 或 block */
  max-width: 8em; /* 4个汉字宽度，约8em */
  white-space: nowrap; /* 不换行 */
  overflow: hidden; /* 溢出隐藏 */
  text-overflow: ellipsis; /* 显示省略号 */
  font-weight: 800;
  font-size: 45px;
  color: #231815;
  margin-top: 116px;
  margin-left: 101px;
  text-align: left;
}
.copy-text-tip{
  margin-top: 25px;
  margin-left: 101px;
  width: 500px;
  height: 55px;
  display: -webkit-box;
  -webkit-line-clamp: 2; /* 限制行数 */
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  font-weight: 400;
  font-size: 14px;
  color: #655E5C;
  text-align: left;
  line-height: 28px;
}
.copy-text-go{
  margin-top: 103px;
  margin-left: 101px;
  display: flex;
  height: 46px;
  align-items: center;
  font-weight: 400;
  font-size: 14px;
  color: #231815;
  cursor: pointer;
}
.copy-text-go > img{
  width: 24px;
  height: 24px;
  margin-left: 5px;
}
</style>



// WEBPACK FOOTER //
// src/view/Page/indexComp/pagesIndex.vue